import React, { useState, useEffect } from 'react';
import { Card } from 'flowbite-react';
import clsx from 'clsx';
import { 
  LoadingSvg
} from '../../../common/icons'
import ErrorComponent from '../../../components/UI/error';

import ApiService from "../../../services/api.service";

import Helper from '../../../common/helper';
import Global from '../../../common/global';

export default function PayWithPoints({languages, isRenewalPage, member, isPwpPointsEnabled, transactionId, locationData, pMethod, nbPoints, enoughNbPoints, localStorageDatas, pmid,  goNextStep}) {

  //const [availablePoints, setAvailablePoints] = useState(true); //FOR LOCAL TESTING PWP WITH POINTS 
  

  const [availablePoints, setAvailablePoints] = useState()
  const [primaryMember, setPrimaryMember] = useState();
  const [suppLength, setSuppLength] = useState();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const [pwpErrorMessage, setPWPErrorMessage] = useState("");

  useEffect(() => {
      if(locationData.PaymentMethod.PayWithPoints && locationData.PaymentMethod.PayWithPoints.Enabled) {
          triggerPayWithPoints();
      }
  }, [])

  async function triggerPayWithPoints() {
      // setAvailablePoints(enoughNbPoints); // COMMENT OUT FOR LOCAL TESTING PWP WITH POINTS
      setAvailablePoints(enoughNbPoints)

      let primaryMember = getPrimaryOwnerMember(localStorageDatas.members);
      setPrimaryMember(primaryMember);

      let suppMembers = getSuppLength(localStorageDatas.members);
      setSuppLength(suppMembers);
  }

  function getPrimaryOwnerMember(members) {
    let member = {};

    for(let i=0;i<members.length;i++) {
        member = members[i];
        if(member.type_of_member == "primary_owner") {
            break;
        }
    }
    return member;
  }


  function getSuppLength(members) {
      let suppLength = 0;
      for(let i=0;i<members.length;i++) {
          let member = members[i];
          if(member.type_of_member == "supp") {
              suppLength++;
          }
      }
      return suppLength;
  }

  function getPwpBc(business_categories) {    
    for(let businessCategoryId in business_categories) {
      // console.log('pwpBc', primaryMember?.selected_product[0]?.business_category_id || businessCategoryId)
        if(isPwpPointsEnabled.exists) {
            //this is the points business category
            let business_category = business_categories[businessCategoryId];
            return {
              // "business_category_id": primaryMember?.selected_product[0]?.business_category_id || businessCategoryId,
              "business_category_id": isPwpPointsEnabled.points_business_category_id,
              "pricelevel": business_categories[isPwpPointsEnabled.points_business_category_id]?.price_level_text || business_category.price_level_text,
              "location": business_category.location,
              "department": business_category.department,
              "partner_public_category_id": business_category.partner_public_category_id,
              "class": business_category.class,
              "post_pay": isPwpPointsEnabled.post_pay_override,
              "sales_type_id": business_category.sales_type_id,
              "digital_card": business_category.digital_card,
              "public_points_table_id": isPwpPointsEnabled.public_points_table_id,
              // "post_pay_override": isPwpPointsEnabled.post_pay_override
            };
        }
    }

    return false;
  }

  function getPwpBcRenewals(business_categories) {
    let pwpParams = {
        // "business_category_id": primaryMember?.selected_product[0]?.business_category_id || business_categories.opportunities[0].business_category_id,
        "business_category_id": isPwpPointsEnabled.points_business_category_id,
        "pricelevel": business_categories[isPwpPointsEnabled.points_business_category_id]?.price_level_text || business_categories.opportunities[0].price_level_text,
        "location": business_categories.location,
        "department": business_categories.department,
        // "partner_public_category_id": business_category.partner_public_category_id,
        "class": business_categories.class,
        "post_pay": isPwpPointsEnabled.post_pay_override,
        // "sales_type_id": business_category.sales_type_id,
        "digital_card": business_categories.opportunities[0].digital_card,
        "public_points_table_id": isPwpPointsEnabled.public_points_table_id,
        // "post_pay_override": isPwpPointsEnabled.post_pay_override
    }   

    if(isPwpPointsEnabled.exists) {
        //this is the points business category
        return pwpParams;
    }
    return false;
  }

  function submitPoints(e) {
    setLoading(true)
    // e.target.disabled = true;
    let payWithPointsParams = {
      ap_transaction_id: transactionId,
      pmid: pmid
    };

    let pwpBc;
    
    if(isRenewalPage) {
      pwpBc = getPwpBcRenewals(localStorageDatas.business_categories)
    } else {
      pwpBc = getPwpBc(localStorageDatas.business_categories);
    }

    
    if(pwpBc) {
      payWithPointsParams["bc"]                           = pwpBc.business_category_id;
      payWithPointsParams["pricelevel"]                   = pwpBc.pricelevel;
      payWithPointsParams["location"]                     = pwpBc.location;
      payWithPointsParams["department"]                   = pwpBc.department;
      payWithPointsParams["partner_public_category_id"]   = pwpBc.partner_public_category_id || '';
      payWithPointsParams["class"]                        = pwpBc.class;
      payWithPointsParams["post_pay"]                     = pwpBc.post_pay;
      payWithPointsParams["sales_type_id"]                = pwpBc.sales_type_id || '';
      payWithPointsParams["digital_card"]                 = pwpBc.digital_card;
      payWithPointsParams["public_points_table_id"]       = pwpBc.public_points_table_id;
      payWithPointsParams["post_pay_override"]            = pwpBc.post_pay_override;
    }
    

    // payWithPointsParams
    setPWPErrorMessage('') //set Error to empty again
    ApiService.payWithPointsPayment(payWithPointsParams)
    .then((response) => response.json())
    .then((result) => {
      setLoading(false)
      //the return of Points API (Success or fail)
      if(result) {
        if(result.error) {
          setPWPErrorMessage(result.error)
        } else if(result.order_complete === true) {
          goNextStep(transactionId, null, "Pay with Points");
        }
      } else {
        setPWPErrorMessage('There was an error occured, please try again later')
      }
    },(error) => {
      setPWPErrorMessage('There was an error occured, please try again later')
      setLoading(false)
      console.error('error', error);
    });
  }


  if(error) {
    return (
      <div>
        Error: {error}
      </div>
    );
  } else if(availablePoints && suppLength == 0) {
  // } else if(suppLength == 0) { test if pwp has no points
    return (
      // <div className="font-medium text-gray">
      //       <div class="mb-3">
      //         <p>Your points balance : {nbPoints} ALL - Accor live Limitless Reward points</p>
      //         <p>You will be using {primaryMember.selected_product[0].points_value} Reward points for an {primaryMember.selected_product[0].item_group_description}</p>
      //       </div>
      //       <button id="submitPointsButton" class='btn inline-block px-5 py-2.5 text-black font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out btn-blue' onClick={(event) => submitPoints(event)}>PAY WITH REWARD POINTS</button>
      // </div>

      

      <div className='holder-text text-center mt-5 mb-5'>
        <div className='holder-title mb-2'>
            <h5 className='text-xl tracking-tight text-gray-900 dark:text-white font-montsterrat font-bold'>{languages && languages.pwpEligibleAllReward ? languages.pwpEligibleAllReward : 'You are eligible to use your ALL Reward points'}</h5>
        </div>
        <div>
          <p className='pt-1 font-montsterrat'>
            <span>{languages && languages.pwpYouHave ? languages.pwpYouHave : 'You have'} </span> 
            {nbPoints} 
            <span>{languages && languages.pwpRewardPoints ? languages.pwpRewardPoints : 'You are not eligible to use your ALL Reward points'}</span>
          </p>
        </div>
        {/* <div>
            <p className='pt-1 font-montsterrat'>Would you like to use these points to pay for this membership?</p>
        </div> */}
        <div className='mt-4'>
          { loading ? (
            <button
                type='button'                
                className='btn inline-block btn-processing px-6 py-2.5 text-white font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>
                <span> <LoadingSvg className="process" /> &nbsp; Processing </span>
            </button>
          ) : 
            <button id="submitPointsButton" class='btn inline-block px-5 py-2.5 text-black font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out btn-blue' onClick={(event) => submitPoints(event)}>{languages && languages.pwpEligibleButton ? languages.pwpEligibleButton : 'USE MY ALL REWARD POINTS'}</button>
          }        
          {/* <a href="#" className='btn btn-blue inline-block px-6 py-2.5 text-white font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>USE MY ALL REWARD POINTS</a> */}
        </div>
        {  pwpErrorMessage ? (
            <div class="mt-5 holder-pwp-error">
              <ErrorComponent errorMessage={pwpErrorMessage}/>
            </div>
          ) : ''
        }
      </div>
    )
  } else if(suppLength > 0) {
    return (
    <div className="font-medium text-gray">
      {languages && languages.pwpSecondaryErrorMessage ? languages.pwpSecondaryErrorMessage : 'Cannot use points with Secondary Members.'}      
    </div>
    )
  } else {
    return (
      <div className='holder-receipt-uneligible holder-text text-center mt-5 mb-5'>
          <div className='holder-title mb-2'>
              <h5 className='text-xl tracking-tight text-gray-900 dark:text-white font-montsterrat font-bold'>{languages && languages.pwpNotEligibleMessage ? languages.pwpNotEligibleMessage : 'You are not eligible to use your ALL Reward points'}</h5>
          </div>
          <div>  
              <p className='pt-1 font-montsterrat'>
                <span>{languages && languages.pwpYouHave ? languages.pwpYouHave : 'You have'} </span> 
                <span>{nbPoints} </span>
                <span>{languages && languages.pwpRewardPoints ? languages.pwpRewardPoints : 'You are not eligible to use your ALL Reward points'}</span>
              </p>
          </div>
          <div className='mt-4 button-receipt'>
              <a href="#" className='btn btn-blue inline-block px-6 py-2.5 text-white font-montsterrat font-medium leading-tight uppercase rounded shadow-md ease-in-out'>{languages && languages.pwpEligibleButton ? languages.pwpEligibleButton : 'USE MY ALL REWARD POINTS'}</a>
          </div>
      </div>
    )
  }  
}
